import { FiltersMap, OptionalFiltersMap } from '@wix/bex-core';
import {
  OffsetCollectionConfig,
  useWixPatternsContainer,
  useWixPatternsContainerOverrides,
  useCreateCollection,
} from '@wix/bex-core/react';
import { useState } from 'react';
import { TableGridSwitchState } from '../state/TableGridSwitchState';

/**
 * @deprecated use useTableGridSwitch instead
 */
export function useOffsetTableGridSwitch<
  T,
  F extends FiltersMap = OptionalFiltersMap,
>(config: OffsetCollectionConfig<T, F>) {
  const createCollection = useCreateCollection();
  const container = useWixPatternsContainer();
  const containerOverrides = useWixPatternsContainerOverrides();

  const [state] = useState(() => {
    const collection = createCollection<T, F>({
      ...config,
      paginationMode: 'offset',
    });

    return new TableGridSwitchState({
      collection,
      container,
      containerOverrides,
    });
  });

  return state;
}
